var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvalonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 40,
    viewBox: "0 0 100 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.2477 7.53086V3.51562L51.2324 7.53086H55.2477Z",
    fill: "#61666C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8418 12.8349H55.2794V8.82812H49.85L45.8418 12.8349Z",
    fill: "#61666C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8926 2.54688V11.9001L54.2478 2.54688H44.8926Z",
    fill: "#61666C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.505 1.17046H56.6672V14.3312H43.5045L43.505 1.17046ZM42.334 15.5017H57.8376V0H42.336L42.334 15.5017Z",
    fill: "#61666C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.16791 30.2096L8.68161 35.258H3.67518L6.16791 30.2096ZM5.57669 28.2656L0 39.6517H1.52051L3.01854 36.5887H9.31578L10.8573 39.6517H12.3992L6.75664 28.2666L5.57669 28.2656Z",
    fill: "#61666C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6747 28.2656L23.2804 37.3912L18.8897 28.2656H17.3457L22.8385 39.6507H23.7253L29.2386 28.2656H27.6747Z",
    fill: "#61666C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4335 30.2086L42.9472 35.258H37.9408L40.4335 30.2086ZM39.8423 28.2656L34.2656 39.6507H35.7866L37.2847 36.5877H43.5804L45.1219 39.6507H46.6664L41.0238 28.2656H39.8423Z",
    fill: "#61666C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6602 28.2656V39.6507H63.5105V38.3409H56.0753V28.2656H54.6602Z",
    fill: "#61666C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_33789_68272",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 40
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5 0H0V39.9471H99.5V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_33789_68272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.3057 34.062C80.3057 31.3915 78.4491 29.471 75.9239 29.471C73.4197 29.471 71.5417 31.391 71.5417 34.062C71.5417 36.733 73.4202 38.632 75.9239 38.632C78.4491 38.632 80.3057 36.712 80.3057 34.062ZM70.1016 34.062C70.1016 30.6399 72.5638 28.1567 75.9239 28.1567C77.0925 28.1423 78.2389 28.4754 79.2177 29.1139C80.1965 29.7524 80.9635 30.6674 81.4212 31.7427C81.8788 32.818 82.0066 34.005 81.7883 35.1531C81.5699 36.3011 81.0153 37.3584 80.1948 38.1905C79.3743 39.0227 78.325 39.5922 77.1801 39.8268C76.0353 40.0614 74.8465 39.9504 73.7649 39.508C72.6832 39.0655 71.7575 38.3116 71.1052 37.3419C70.453 36.3722 70.1036 35.2306 70.1016 34.062Z",
    fill: "#61666C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.0689 28.4062H90.8004L98.1043 36.8162V28.4062H99.5025V39.654H98.7899L91.4665 31.244V39.654H90.0684L90.0689 28.4062Z",
    fill: "#61666C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvalonLogo);
export default __webpack_public_path__ + "static/media/avalon-logo.77482be4a7ada39e3d339ea35c17af26.svg";
export { ForwardRef as ReactComponent };